export const SPOTLIGHT_ONBOARDING_STEP1_TARGET =
	'platform.search-platform.rovo-changeboarding-app-selectors';
export const SPOTLIGHT_ONBOARDING_STEP2_TARGET =
	'platform.search-platform.rovo-changeboarding-product-filters';
export const SPOTLIGHT_MESSAGE_ID = 'search-platform-filters-changeboarding';
